define('models/AddressCollection',['underscore','backbone','ObjectCollection','LocalStorage','app','models/AddressModel'],function (_,Backbone,ObjectCollection,LocalStorage,app,AddressModel) {
    //
    // Collection Address
    //
    var AddressCollectionPrototype = {

        name:'AddressCollection',
        route:'apiAddressCollection',
        model:AddressModel,
        privateApi:true,
        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(collection,arguments);
            //
            collection.on('all',collection.allEvents,collection);
            collection.on('change:deleted',collection.changeDeleted,collection);
            //
        },
        allEvents:function(eventType){
        },
        changeDeleted:function(addressModel,deleted){
            if(deleted == 0){
                // address undelete
                this.trigger('undelete',addressModel);
            }
        },
        size:function(withDeleted){
            if(withDeleted){
                return Backbone.Collection.prototype.size.apply(this);
            }
            return this.where({deleted:0}).length;
        },
        containsLocality:function(locality){
            locality = locality.toLowerCase();
            return this.some(function(address){
                var city = address.get('city') || '';
                return city.toLowerCase() == locality
            }) !== false;
        },
        createAddressFromPlace:function(place,attach_to_cart,data,customer_primary){
            //
            // instancie une adresse et la sauvegarde à partir d'un place_id
            //
            var collection = this,
                address = AddressModel.createAddressFromPlace(place,attach_to_cart,data,customer_primary);

            function SyncAddress()
            {
                // attention n'ajouter l'adresse que si elle ne préexiste pas dans le carnet d'adresse.
                if(!collection.findWhere({id_address:address.id})){
                    collection.add(address);
                }
                if(attach_to_cart == 1){
                    app.getCart().set('id_address_delivery', address.id);
                }
                if(customer_primary){
                    app.getCustomer().set('id_address_primary', address.id);
                }
            }

            // sauf pour le cas où le placeModel n'est pas défini
            if(address && address.id != 'empty_address'){
                // on la sauvegarde
                address.once('sync', SyncAddress);
                // la collection est obligatoire pour créer une address, pour obtenir l'url
                address.save();
            }

            return address;
        }
    };

    var AddressCollection = ObjectCollection
        .extend(LocalStorage)
        .extend(AddressCollectionPrototype);

    return AddressCollection;
});
